module.exports = __webpack_public_path__ + "img/gerenweishenghuuli_icon_zj.eecd396a.png";